import { useState } from "react";
import { MoveHorizontal } from "lucide-react";
import { BEFORE_AFTER } from "../../lib/content";

const Slider = ({ item, index }) => {
  const [pos, setPos] = useState(50);
  return (
    <div className="group">
      <div
        data-testid={`before-after-${index}`}
        className="relative w-full aspect-[4/3] overflow-hidden rounded-xl border border-gold/25 select-none"
      >
        <img src={item.after} alt="After" className="absolute inset-0 w-full h-full object-cover" draggable={false} />
        <span className="absolute top-3 right-3 z-10 text-[10px] uppercase tracking-widest bg-black/60 text-gold px-3 py-1 rounded-full border border-gold/30">After</span>

        <div className="absolute inset-0 overflow-hidden" style={{ width: `${pos}%` }}>
          <img src={item.before} alt="Before" className="absolute inset-0 h-full object-cover max-w-none" style={{ width: `${10000 / pos}%` }} draggable={false} />
          <span className="absolute top-3 left-3 text-[10px] uppercase tracking-widest bg-black/60 text-white px-3 py-1 rounded-full border border-white/20">Before</span>
        </div>

        <div className="absolute top-0 bottom-0 z-20 -ml-px" style={{ left: `${pos}%` }}>
          <div className="w-0.5 h-full bg-gold" />
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-gold text-black flex items-center justify-center shadow-lg">
            <MoveHorizontal size={18} />
          </div>
        </div>

        <input
          type="range"
          min={0}
          max={100}
          value={pos}
          data-testid={`before-after-range-${index}`}
          onChange={(e) => setPos(Number(e.target.value))}
          className="absolute inset-0 w-full h-full opacity-0 cursor-ew-resize z-30"
          aria-label={`${item.label} before after slider`}
        />
      </div>
      <p className="mt-4 text-center font-serif text-lg text-white">{item.label}</p>
    </div>
  );
};

export const BeforeAfter = () => {
  return (
    <section id="before-after" data-testid="before-after-section" className="relative py-24 md:py-32 bg-[#0A0A0A] border-t border-gold/10">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <p className="font-cursive text-gold text-2xl md:text-3xl">The Transformation</p>
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-white mt-1">Before &amp; After</h2>
          <div className="gold-divider w-40 mx-auto mt-6" />
          <p className="mt-6 text-gray-400">Drag the slider to see how we turn hazards and overgrowth into safe, beautiful spaces.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {BEFORE_AFTER.map((item, i) => (
            <Slider key={item.label} item={item} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
};
